import type { SelfOwnedWidgetDefinition } from '../WidgetDefinition';
import { faCabinetFiling } from '@fortawesome/pro-regular-svg-icons/faCabinetFiling';
import type { FilingsWidgetModel } from 'src/models/FilingsWidgetModel';
import { FilingsWidgetModelImpl } from 'src/models/FilingsWidgetModel/impl';
import type { FilingsWidgetState } from 'src/models/TimeListWidgetState/schemas';

export const filingsWidgetDefinition: SelfOwnedWidgetDefinition<FilingsWidgetState, FilingsWidgetModel> = {
    type: 'filings',
    nameKey: 'widgets::filings::name',
    roles: ['widgets::filings'],
    icon: faCabinetFiling,
    category: 'widgets::categories::research',
    defaultDimensions: { h: 0.8, w: 0.33, x: 0.33, y: 0.1 },
    widgetClass: FilingsWidgetModelImpl,
};
